import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Label from "../components/Label";
import Footer from "../components/Footer";
function DisasterRecovery(props) {
  return (
    <>
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div
                  className="col-md-8 col-md-offset-2 intro-text"
                  style={{ marginBottom: -100 }}
                >
                  <ScrollAnimation animateIn="fadeInLeft" delay={0.5 * 1000}>
                    <h1 style={{ fontFamily: "Audiowide", color: "orange" }}>
                      Disaster Recovery
                      <span></span>
                    </h1>
                  </ScrollAnimation>
                  <ScrollAnimation animateIn="fadeInRight" delay={0.9 * 1000}>
                    <p style={{ fontFamily: "monospace" }}>
                      Maintaining or reestablishing vital infrastructure and
                      systems.
                    </p>
                  </ScrollAnimation>
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>
                  <Label />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Footer />
    </>
  );
}

export default DisasterRecovery;
